<template>
  <App
    left-arrow
    title="客户跟进"
    @click-right="onClickRight"
    class="allSearch"
  >
    <Tabs
      v-model="tabActive"
      slot="extra"
      @change="tableChange"
    >
      <Tab
        :title="$i.title"
        v-for="$i in tabsData"
        :key="$i.label"
        :name="$i.label"
      >
      </Tab>
    </Tabs>
    <PullRefresh
      @refresh="onRefresh"
      v-model="loading"
    >
      <List
        v-model="loading"
        :immediate-check="false"
        :error.sync="error"
        :finished="finished"
        :finished-text="total === 0 ? 'No data!' : 'No more items.!'"
        error-text="Loading failed. Click to retry"
        @load="Onload"
      >
        <CardItem
          v-for="$items in list"
          :key="$items.id"
          @finish="finish"
          :cardInfo="$items"
          :type="tabActive"
        />
      </List>
    </PullRefresh>
  </App>
</template>

<script>
import { Tab, Tabs, PullRefresh, List, Toast, Dialog } from 'vant'
import { debounce } from 'lodash-es'
import { tabsData } from './attr.js'
import CardItem from './components/card/index'
import { endList, notToShopList, finishClient } from '@/api/follow/index'
import { getClueSource2 } from '@/api/chargequery/index'
import '@/style/vant-patch.less'
export default {
  name: 'customerFollowUp',
  data () {
    return {
      showResult: false,
      hasDate: true,
      loading: false,
      finished: false,
      error: false,
      list: [],
      tabActive: this.$route.query.tabName,
      tabsData: [],
      page: 1,
      size: 10,
      total: 0
    }
  },
  components: {
    Tab,
    Tabs,
    CardItem,
    List,
    PullRefresh
  },
  methods: {
    getData: debounce(function () {
      if (this.finished) return
      switch (this.tabActive) {
        case 'trend':
          this.getEndList()
          break;
        case 'notInto':
          this.getNotToShopList()
          break;
      }
    }, 600, { leading: true, trailing: false }),
    // 获取客户来源渠道信息
    async getClueSource () {
      const res = await getClueSource2()
      if (res.success) {
        this.sourceList = res.data
      } else {
        Toast(res.msg)
      }
    },
    // 客户动向
    async getEndList () {
      try {
        /* Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true
        }) */
        const res = await endList({ 'page': this.page, 'size': this.size, 'currentIdentity': this.$route.query.currentIdentity })
        Toast.clear()
        if (res && res.success) {
          this.total = res.data.total
          this.list = [...this.list, ...res.data.records]
          if (this.list.length === res.data.total) {
            this.finished = true
          } else {
            this.page++
          }
          this.error = false
          this.loading = false
        } else {
          this.error = true
          this.loading = false
          Toast(res.msg)
        }
      } catch (error) {
        Toast.clear()
        console.log(error)
        this.error = true
        this.loading = false
      }
    },
    // 未进店
    async getNotToShopList () {
      try {
        /* Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true
        }) */
        const res = await notToShopList({ 'page': this.page, 'size': this.size, 'currentIdentity': this.$route.query.currentIdentity })
        Toast.clear()
        if (res && res.success) {
          this.sourceList.forEach(el => {
            res.data.records.forEach(item => {
              if (el.threelevelCode === item.source) {
                item.source = el.threelevelName
              }
            })
          })
          this.total = res.data.total
          this.list = [...this.list, ...res.data.records]
          if (this.list.length === res.data.total) {
            this.finished = true
          } else {
            this.page++
          }
          this.error = false
          this.loading = false
        } else {
          this.error = true
          this.loading = false
          Toast(res.msg)
        }
      } catch (error) {
        Toast.clear()
        console.log(error);
        this.error = true
        this.loading = false
      }

    },
    // 完成任务
    finish (id) {
      Dialog.confirm({
        title: '确认',
        message: '确认完成任务',
      })
        .then(async () => {
          /* Toast.loading({
            message: 'Loading...',
            forbidClick: true,
            loadingType: 'spinner',
            overlay: true
          }) */
          const res = await finishClient({ 'trendsid': id })
          Toast.clear()
          if (res.success) {
            this.page = 1
            this.list = []
            this.getEndList()
          } else {
            Toast(res.msg)
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    tableChange () {
      this.page = 1
      this.list = []
      this.total = 0
      this.finished = false
      this.loading = false
      this.getData()
    },
    // 下拉刷新
    onRefresh () {
      this.page = 1
      this.finished = false
      this.list = []
      this.total = 0
      this.getData()
    },
    Onload () {
      this.getData()
      this.loading = false
    },
    init () {
      this.page = 1
      this.list = []
      this.total = 0
      this.finished = false
      this.loading = false
      this.getClueSource()
      this.tabsData = tabsData
      this.tabActive = this.$route.query.tabName
      this.getData()
    },
    onClickRight () {
      this.showResult = false
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>